import { map } from 'rxjs/operators';
import APIv4ResponseProcessor from '../../Shared/Infrastructure/Http/APIv4ResponsePipeProcessor';
import WISHLIST_EXCEPTIONS from './Exceptions/APIv4WishlistExceptionMap';
import APIv4WishlistResponseAdapter from './Adapters/APIv4WishlistResponseAdapter';
const ENDPOINT_GET_WISHLIST = '/customer/me/carts';
const ENDPOINT_UPDATE_WISHLIST = '/cart';
class APIv4WishlistRepository {
  constructor(context, samHttpClient) {
    this.context = context;
    this.samHttpClient = samHttpClient;
  }
  get(params, accessToken) {
    const url = `${this.context.baseUrl}${ENDPOINT_GET_WISHLIST}?API-Version=${params.APIVersion}&country=${params.country}&projectID=${params.projectID}`;
    return this.samHttpClient.get(url, {
      headers: {
        'access-token': accessToken
      }
    }).pipe(APIv4ResponseProcessor.handle(WISHLIST_EXCEPTIONS), map(response => APIv4WishlistResponseAdapter.get(response.response_data)));
  }
  update(data, accessToken) {
    const url = `${this.context.baseUrl}${ENDPOINT_UPDATE_WISHLIST}/${data.cartID}`;
    const requestData = JSON.stringify(data.params);
    const headers = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    };
    return this.samHttpClient.post(url, `request_data=${requestData}&access_token=${accessToken}&API-Version=${data.APIVersion}&_method=PATCH`, headers).pipe(APIv4ResponseProcessor.handle(WISHLIST_EXCEPTIONS), map(response => response));
  }
}

export { APIv4WishlistRepository as default };